import { render, staticRenderFns } from "./foros_curso.vue?vue&type=template&id=d1d99866"
import script from "./foros_curso.vue?vue&type=script&lang=js"
export * from "./foros_curso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports